let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6Oc3K")).then(() => parcelRequire('lbhiX'));